export default __webpack_public_path__ + "static/media/gallery-wip-emitter_04.d1e8732f.jpg";